import { useDispatch, useSelector } from "react-redux";
import { getMe, LogOut } from "../features/authSlice";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { HiKey, HiLogout, HiChevronDown } from "react-icons/hi";


function initials(name = "") {
  return name.slice(0, 2).toUpperCase();
}

function LoginStatus() {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    dispatch(LogOut());
    navigate("/");
  };

  if (!user) return null;

  const roleLabel = user.level || `Level ${user.user_lvl}`;

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2.5 rounded-lg px-2 py-1.5 hover:bg-white/10 transition-colors"
      >
        {/* Avatar */}
        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-xs font-bold flex-shrink-0 ring-2 ring-blue-400/50">
          {initials(user.username)}
        </div>
        {/* Name + role */}
        <div className="text-left hidden sm:block">
          <p className="text-white text-xs font-semibold leading-tight">{user.username}</p>
          <p className="text-blue-300 text-[10px] leading-tight">{roleLabel}</p>
        </div>
        <HiChevronDown
          className={`text-gray-400 text-sm transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-xl shadow-2xl z-50 overflow-hidden">
          {/* User info header */}
          <div className="px-4 py-3 border-b border-gray-700 bg-gray-900/60">
            <p className="text-white text-xs font-semibold truncate">{user.username}</p>
            <p className="text-blue-400 text-[10px] mt-0.5">{roleLabel}</p>
          </div>
          {/* Menu */}
          <div className="py-1">
            <NavLink
              to="/users/update"
              onClick={() => setOpen(false)}
              className="flex items-center gap-2.5 px-4 py-2 text-xs text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
            >
              <HiKey className="text-gray-400 text-sm flex-shrink-0" />
              Change Password
            </NavLink>
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-2.5 px-4 py-2 text-xs text-red-400 hover:bg-red-900/30 hover:text-red-300 transition-colors"
            >
              <HiLogout className="text-sm flex-shrink-0" />
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginStatus;
